<template>
  <div>
    <div style="min-height: 300px;" v-loading="isShow" element-loading-text="拼命加载中" v-if="isShow == true"></div>
    <div class="info_list" v-else>
      <div class="userGroup_info"> <span>用户管理范围组信息：</span> </div>
      <el-form ref="form" :model="form" label-width="110px">
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="组织机构:" prop="orgName">
              <div class="line_title_name">{{aaDataList.orgName}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="组名称:" prop="groupName">
              <div class="line_title_name">{{aaDataList.groupName}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="组描述:" prop="groupDesc">
              <div class="line_title_name">{{aaDataList.groupDesc}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="组模式:" prop="groupMode">
              <!-- <div class="line_title_name">{{aaDataList.groupMode == 0 ? '教研组' : '课改组'}}</div>  -->
              <div class="line_title_name">{{aaDataList.groupMode == 0 ? '通用' : '按成员分配'}}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <comm_action_bar style="border-bottom: none;">
        <el-input style="float: right;" placeholder="请输入内容" v-model="input5" @keyup.native.enter="selectInput" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="selectInput"></el-button>
        </el-input>
      </comm_action_bar>
      <el-table :data="listArr.slice((currentPage-1)*pagesize,currentPage*pagesize)">
        <el-table-column sortable label="成员姓名" prop="userName"></el-table-column>
        <el-table-column label="成员机构" prop="group"></el-table-column>
        <el-table-column label="成员描述" prop="orgName"></el-table-column>
        <el-table-column label="成员类型" prop="tpye"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5,10,15,20,25,30]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listArr.length">
      </el-pagination>
      <div class="userGroup_info">
        <span>范围组选项：</span>
        <div> 范围配置模式：
          <el-radio-group v-model="radio" style="margin: 16px 0;" @change="checkedRadio">
            <el-radio v-for="item in radioList" :key="item.id" :label="item.seiValue">{{item.seiName}}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="last_line">
        <el-form label-width="120px" v-if=" radio == 'school' ">
          <el-row>
            <el-col :span="20">
              <el-form-item label="学段：">
                <el-checkbox-group v-model="aaDataList.gradations">
                  <el-checkbox v-for="gradation in aaDataList.gradations" disabled :label="gradation" :key="gradation.gradationId">{{gradation.gradationName}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="学校：">
                <el-checkbox-group v-model="aaDataList.campuses">
                  <el-checkbox v-for="campus in aaDataList.campuses" disabled :label="campus" :key="campus.campusId">
                    {{campus.campusName}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="年级：">
                <div class="el-collapse-item" v-for="grade in grades" :key="grade.gradeId">
                  <div class="el-collapse-item__header">
                    <el-checkbox-group v-model="grades">
                      <el-checkbox disabled :label="grade" :key="grade.gradeId">{{grade.gradeName}}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="el-collapse-item__wrap">
                    <div class="el-collapse-item__content">
                      <el-checkbox-group v-model="grade.courses">
                        <el-checkbox v-for="course in grade.courses" disabled :label="course" :key="course.courseId">
                          {{course.courseName}}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div v-if=" radio == 'org' ">
          <el-table :data="listOrg.slice((currentPage2-1)*pagesize,currentPage2*pagesize)" border>
            <el-table-column label="机构名称" prop="orgName"></el-table-column>
            <el-table-column label="机构编码" prop="orgCode"></el-table-column>
            <el-table-column label="名称路径" prop="namePath"></el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="currentPage"
            :page-sizes="[5,10,15,20,25,30]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listOrg.length"
            v-if="listOrg.length>4">
          </el-pagination>
        </div>
        <div v-if=" radio == 'user' ">
          <el-table :data="listUser.slice((currentPage3-1)*pagesize,currentPage3*pagesize)" border>
            <el-table-column label="用户名称" prop="userName"></el-table-column>
            <el-table-column label="唯一编码" prop="idCard"></el-table-column>
            <el-table-column label="机构名称" prop="orgName"></el-table-column>
          </el-table>
          <el-pagination
          @size-change="handleSizeChange3"
          @current-change="handleCurrentChange3"
          :current-page="currentPage"
          :page-sizes="[5,10,15,20,25,30]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listUser.length"
          v-if="listUser.length>4">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    aaDataList:{ type: Object },
    groupId:{ type: String },
    isShow:{ type: Boolean, default: true } 
  },
  data () {
    return {
      input5:'',
      radio: 'school',
      checkAll: false,
      checkAlls: false,
      isIndeterminate: true,
      isIndeterminates: true,
      form:{},
      schools:[],
      grade:[],
      studying:[],
      school:[],
      listArr:null,
      listOrg:[],
      listUser:[],
      currentPage:1,
      pagesize:5,
      currentPage2:1,
      pagesize2:5,
      radioList:[],
      grades:[],
      courses:[],
    }
  },
  watch:{
    aaDataList(){
      this.query()
    }
  },
  mounted() {
    let vm = this
    vm.query()
  },
  methods:{
    query(){
      let vm = this
      http.get( InterfacePrefix['platform']+'/enum/queryByCodes/manageType/' ).then(xhr=>{
        vm.radioList = xhr.data
      })
      if(vm.aaDataList.groupMode == 1){
        let members = []
        members.push(vm.aaDataList)
        vm.listArr = members
        if(vm.listArr != []){
          vm.setInfo()
        }
      }else if(vm.aaDataList.groupMode == 0){
        vm.listArr = _.cloneDeep(vm.aaDataList.members)
        if(vm.listArr != []){
          vm.setInfo()
        }
      }
      _.each(vm.aaDataList.gradations,gt=>{
        let i = _.indexOf(vm.studying,gt.gradationName)
        if(i == -1){
          vm.studying.push(gt.gradationName)
        }
      })
      _.each(vm.aaDataList.schools,gt=>{
        let j = _.indexOf(vm.schools,gt.schoolName)
        if(j == -1){
          vm.schools.push(gt.schoolName)
        }
      })
      _.each(vm.aaDataList.grades,gt=>{
        let l = _.indexOf(vm.grade,gt.gradeName)
        if(l == -1){
          vm.grade.push(gt.gradeName)
        }
      })
      if(vm.aaDataList.orgs&&vm.aaDataList.orgs.length>0){
        vm.listOrg = _.cloneDeep(vm.aaDataList.orgs)
      }else{
        vm.listOrg = []
      }
      if(vm.aaDataList.users&&vm.aaDataList.users.length>0){
        vm.listUser = _.cloneDeep(vm.aaDataList.users)
      }else{
        vm.listUser = []
      }
    },
    setInfo(){
      let vm = this
      vm.grades = vm.aaDataList.grades;
      vm.courses = vm.aaDataList.courses;
      vm.grades = _.map(vm.grades, o => {
        return {
          gradeId: o.gradeId,
          gradeName: o.gradeName
        };
      });
      vm.grades = _.uniqBy(vm.grades, "gradeId");
      vm.courses = _.map(vm.courses, o => {
        return {
          courseId: o.courseId,
          courseName: o.courseName,
          gradeId: o.gradeId
        };
      });
      vm.courses = _.uniqWith(
        vm.courses,
        (o1, o2) =>
          _.isEqual(o1.courseId, o2.courseId) && _.isEqual(o1.gradeId, o2.gradeId)
      );

      _.forEach(vm.grades, grade => {
        grade.courses = [];
        _.forEach(vm.courses, course => {
          if (_.isEqual(grade.gradeId, course.gradeId)) {
            grade.courses.push(course);
          }
        });
      });
      vm.isShow = false
    },
    selectInput(){
      let vm = this
      let arrs = _.cloneDeep(vm.aaDataList.members)
      vm.listArr = []
      if(vm.input5 != ''){
        arrs.map(li=>{
          if(li.userName.search(vm.input5) != -1){
            vm.listArr.push(li)
          }
        })
      }else{
        vm.input5 = ''
        vm.listArr = arrs
      }
    },
    handleCheckAllChange(val) {
      let vm = this
      this.school = val ? school : [];
      this.isIndeterminate = false;
    },
    handleCheckAlls(val) {
      let vm = this
      this.grade = val ? grade : [];
      this.isIndeterminates = false;
    },
    handleSizeChange(val) {
      this.pagesize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    f(val){
      this.school = val
    },
    checkedGrade(val){
      this.grade = val
    },
    checkedRadio(val){
      let vm = this
    },
  }
}
</script>
<style lang="less" scoped>
  .info_list{ min-height: 300px;
    .userGroup_info{ margin: 16px 0; 
      >span{font-size: 24px; font-weight: 700; color: #333; }
    }
  }
  .check_box{ display: inline-block; padding-right: 18px; }
  .check_box_line{ height: 34px; line-height: 34px; border-bottom: 1px solid #e5e7ea ; }
  .line_title_name{ overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
</style>



// WEBPACK FOOTER //
// src/components/setting/basic_information/permission/common/info_list.vue